module.exports = __webpack_public_path__ + "static/media/live-receptionist.42b3b3df.svg";